import React, { useEffect, useState } from "react";
import { rolesAndPermission } from "../../../../../service/rolesAndPermission";
import AlertModal from "../../../../../widgets/alertModal";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FIELD_VALIDATIONS } from "../../../../../constants/fieldValidations";


interface InnerPageRolesProps {
  setTab: (type: string) => void;
  setRole: (type: string) => void;
  setReason: (type: string) => void;
  setSelectedCodes: (type: any) => void;
  role: string;
  reason: string;
  selectedCodes: any;
  id: any;
  setUseEffect: (type: boolean) => void;
  setShowToast: (type: any) => void;
  setToastMessage: (type: any) => void;
  setToastType: (type: any) => void;
  setId: (type: any) => void;
  setModalName: (type: any) => void;
  modalName: string;
}

const InnerPageRoles: React.FC<InnerPageRolesProps> = ({ setTab, setRole, setSelectedCodes, role, setReason, reason, selectedCodes, id, setUseEffect, setShowToast, setId, setToastMessage, setToastType, setModalName, modalName }) => {

  const { t } = useTranslation();

  const [moduleNames, setModuleNames] = useState<Array<any>>([]);
  const [permissionTablelist, setPermissionTable] = useState<Array<any>>([]);
  const [selExposureAreaId, setSelExposureAreaId] = useState(1);
  const [useEffectRequired, setUseEffectRequired] = useState(false);
  const [selectAllCodes, setSelectAllCodes] = useState<Array<any>>([]);

  interface Errors {
    reason?: string;
    role?: string;
    selectPermission?: string;
  }
  const [errors, setErrors] = useState<Errors>({});
  const [userId, setUserId] = useState<number>(0);
  const [roleAlert, setRoleAlert] = useState(false);

  // render all initial apis
  useEffect(() => {
    var storedData = localStorage.getItem('userDetails');

    if (storedData) {
      var storedObject = JSON.parse(storedData);
      setUserId(storedObject[0].id)
    }
    getModuleName();
    permissionTable(undefined);
  }, []);

  useEffect(() => {
    permissionTable(selExposureAreaId)
    setUseEffectRequired(false)
  }, [useEffectRequired, selExposureAreaId])

  // handle role change
  const handleRoleChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    const regex = /^[a-zA-Z ]*$/;
    const MAX_ROLE_LENGTH = 50;
    
    if (name === "reason") {
      setReason(value);
    } else if (regex.test(value) && value.length <= MAX_ROLE_LENGTH) {
      setRole(value);
    }
    
    // Set error if role exceeds max length
    if (name !== "reason" && value.length > FIELD_VALIDATIONS.LOCATION_NAME.MAX_LENGTH) {
      setErrors(prev => ({
        ...prev,
        role: FIELD_VALIDATIONS.LOCATION_NAME.ERROR_MESSAGE
      }));
    } else if (name !== "reason") {
      // Clear the error if the input is valid
      setErrors(prev => ({
        ...prev,
        role: undefined
      }));
    }
  };

  // get module names
  const getModuleName = async () => {
    try {
      const response = await rolesAndPermission.getModuleName();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  name: element.name,
                };
              }
            );
            setPermissionTable([])
            const firstId = rowData.length > 0 ? rowData[0]?.id : null;
            permissionTable(firstId)
            setSelExposureAreaId(firstId)
            setModuleNames(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error("exposure response", error);
    }
  };

  // get permissions listing
  const permissionTable = async (id: number | undefined) => {
    try {
      const response = await rolesAndPermission.permissionTable(id);
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            if (!id) {
              let codes: string[] = response.data.map(
                (element: any) => element.code
              );
              setSelectAllCodes(codes);
            } else {
              let rowData: any = response.data.map(
                (element: any, index: number) => {
                  return {
                    slno: index + 1,
                    id: element.id,
                    title: element.title,
                    code: element.code,
                    status: element.status,
                    module_id: element.module_id,
                  };
                }
              );

              setPermissionTable(rowData);
            }
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setPermissionTable([]);
      }
    } catch (error) {
      console.error("exposure response", error);
    }
  };

  // handle module name click
  const onExpAreaNameClick = (id: number, name: string) => {
    setSelExposureAreaId(id);
    permissionTable(id);
  };

  // handle checkbox change
  const handleCheckboxChange = (code: any) => {
    setSelectedCodes((prevSelectedCodes: any) => {
      if (prevSelectedCodes.includes(code)) {
        return prevSelectedCodes.filter((c: any) => c !== code);
      } else {
        return [...prevSelectedCodes, code];
      }
    });
  };

  // handle add role submit
  const handleRoleSubmit = async () => {
    const permissionsString = selectedCodes.join(',');
    const dataToSend = {
      "user_id": userId,
      "name": role,
      "permissions": permissionsString,
      "id": id,
      "interface_name": "Roles and Permission",
      "reason": reason
    }
    try {
      const response = await rolesAndPermission.addRole(dataToSend);
      if (response.status && response.statusCode === 200) {
        setToastType("success")
        setToastMessage(response.message)
        setShowToast(true)
        setRoleAlert(false)
        handleCancel();
        setUseEffect(true)
        setUseEffectRequired(true)
        setTab("1")
      } else {
        setToastType("error")
        setToastMessage(response.message)
        setShowToast(true)
        setRoleAlert(false)

      }

    } catch (error) {
      console.error('Plate response', error);
    }
  }

  // handle cancel modal
  const handleCancel = () => {
    setSelectedCodes([]);
    setRole("");
    setReason("");
    setId("");
    setTab("1")
    setId("")
    setErrors({})
  }

  //  handle submit click
  const handleSubmit = () => {
    const errors: Errors = {};

    if (id && !reason) {
      errors.reason = t('applicationConfiguration.errorsReason');
    }
    if (!role) {
      errors.role = t('applicationConfiguration.errorsRole');
    }
    if (selectedCodes == "") {
      errors.selectPermission = t('applicationConfiguration.errorsPermission');
    }
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    setRoleAlert(true);
    setErrors({});
  };

  // handle select all roles
  const handleSelectAllClick = () => {
    if (selectAllCodes?.length === selectedCodes?.length) {
      setSelectedCodes([]);
    } else {
      setSelectedCodes(selectAllCodes);
    }
  };

  return (
    <div>
      <nav aria-label="breadcrumb" className="breadcrumb-container row">
        <div className='col-10 d-flex'>
          <ol className="breadcrumb">
            <li className="breadcrumb-item dashboard-hover">
              <Link to="/rolesAndPermission" onClick={(e) => handleCancel()}>
                {t('applicationConfiguration.rolesandPermission')}
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">{modalName} {t('applicationConfiguration.role')}</li>
          </ol>
        </div>
      </nav>

      <div className="form-group my-3 px-2 ">
        <label htmlFor="">
          {`${modalName} ${t('applicationConfiguration.role')}`}<span style={{ color: "red" }}>*</span>
        </label>
        <br />
        <input
          id="userId"
          value={role}
          name="userId"
          type="text"
          placeholder={t('applicationConfiguration.createRole')}
          className="create-role"
          onChange={handleRoleChange}
          maxLength={150}
        />
        {errors.role && <p className="errorText">{errors.role}</p>}
      </div>

      {id && (
        <div className="form-group my-3 px-2 ">
          <label htmlFor="" className='ReasonLabel'>{t('applicationConfiguration.reason')}<span style={{ color: "red" }}>*</span></label>
          <br />
          <input
            id="reason"
            value={reason}
            name="reason"
            type='text'
            placeholder={t('applicationConfiguration.reason')}
            className="create-reason"
            onChange={handleRoleChange}
          />
          {errors.reason && <p className="errorText">{errors.reason}</p>}
        </div>
      )}

      <div className="mt-5 row">
        <div className="col-md-2 area-names ml-5 ">
          <h3 className="filter-head mb-3" style={{ textAlign: "center" }}>
            {t('applicationConfiguration.module')}
          </h3>
          <div
            className="outer-area"
            style={{ overflowY: "scroll", height: "60vh" }}
          >
            {moduleNames &&
              moduleNames.map((exp_names) => (
                <div
                  className={
                    permissionTablelist[0]?.module_id === exp_names?.id
                      ? "selAreaDetails"
                      : "area-detail"
                  }
                  key={exp_names.id}
                  onClick={() =>
                    onExpAreaNameClick(exp_names.id, exp_names.name)
                  }
                >
                  {exp_names.name}
                </div>
              ))}
          </div>
        </div>

        <div className="col-md-9 table-footer">
          <div className="form-group" style={{ marginTop: "15px", marginBottom: "10px" }}>
            <button className="squareOrangeBtn3" onClick={handleSelectAllClick}>
              {selectAllCodes?.length === selectedCodes?.length ? t('common.unselectAll') : t('common.selectAll')}
            </button>
          </div>
          {errors.selectPermission && <p className="errorText">{errors.selectPermission}</p>}
          <table className="checkbox-table ">
            <thead>
              <tr>
                <th>{t('applicationConfiguration.slNo')}</th>
                <th>{t('applicationConfiguration.permission')}</th>
                <th>{t('applicationConfiguration.select')}</th>
              </tr>
            </thead>
            <tbody>
              {permissionTablelist.map((permission, index) => (
                <tr key={permission.id}>
                  <td>{index + 1}</td>
                  <td>{permission.title}</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedCodes.includes(permission.code)}
                      onChange={() => handleCheckboxChange(permission.code)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="col-md-11 colonyCountBottomSec mx-5 py-1 mb-5">
          <button className="modalCancelBtn" onClick={() => handleCancel()}>
            {t('buttons.cancel')}
          </button>
          <button className="squareOrangeBtn3" onClick={() => handleSubmit()}>
            {t('buttons.submit')}
          </button>
        </div>
      </div>

      <AlertModal
        show={roleAlert}
        onHide={() => setRoleAlert(false)}
        title={t('common.alert')}
        message={`${modalName} ${t('applicationConfiguration.role')}`}
        onConfirm={handleRoleSubmit}
      />
    </div>
  );
};

export default InnerPageRoles;
